import { render } from "./Feedback.vue?vue&type=template&id=5487ef7e&scoped=true&ts=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=ts"
export * from "./Feedback.vue?vue&type=script&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=5487ef7e&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5487ef7e"]])

export default __exports__